import Link from "next/link";
import React from "react";

const Banner = () => {
  return <>
    <div className="items-center">
      <div>
        <h1 className="font-serif text-xl mb-2">
          <span className="text-emerald-600 font-bold text-cen">
            Original 
          </span>{" "}
          Speedcubes & Puzzles
        </h1>

        <p className="text-gray-500">
          See Our latest discounted products from here and select
          <Link href="#discount" className="text-emerald-600 ml-1">
            discounted product
          </Link>
        </p>
      </div>
      
    </div>
  </>;
};

export default Banner;
